import { calcWidth, deviceWidth, isWeb } from '../../../utils/dimensions';

export const PAGE_WIDTH = isWeb ? calcWidth(410) : deviceWidth - calcWidth(120);

export enum EPreviewMode {
  DASHBOARD = 'DASHBOARD',
  PREVIEW = 'PREVIEW',
}
